// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__28LiW","rootSmall":"AddTileButton_rootSmall__UPqKY"};